import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Audience } from './components/Audience';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-navy-900 font-sans selection:bg-gold-500/30" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Hero data-id="element-2" />
      <SocialProof data-id="element-3" />
      <Audience data-id="element-4" />
      <Modules data-id="element-5" />
      <Bonuses data-id="element-6" />
      <Testimonials data-id="element-7" />
      <Pricing data-id="element-8" />
      <FAQ data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}